module.exports = __webpack_public_path__ + "img/2.23f19c48.png";